import React, { ReactElement, ReactNode } from 'react';

import './SmartLink.scss';

type SmartLinkContainerProps = {
  children: ReactNode;
  contentEditable?: boolean;
};

export function SmartLinkContainer({ children, ...restProps }: SmartLinkContainerProps): ReactElement {
  return (
    <span className="SmartLinkContainer" {...restProps}>
      {children}
    </span>
  );
}

type SmartLinkLogoProps = {
  src?: string;
};

export function SmartLinkLogo(props: SmartLinkLogoProps): ReactElement {
  return <img className="SmartLinkLogo" {...props} />;
}
